module.exports = __webpack_public_path__ + "img/maritime_scene.90ba45b6.webp";